<template>
  <svg
    class="vessel-course-caution-icon"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7057_1938)">
      <g class="auto-cognition-frame">
        <path
          d="M0 10.8889L0 2.67029e-05H10.8889V1.55558H1.55556L1.55556 10.8889H0Z"
          fill="#F2F61C"
          fill-opacity="0.8"
        />
        <path
          d="M10.8889 28.0002H2.67029e-05L2.67029e-05 17.1114H1.55558L1.55558 26.4447H10.8889V28.0002Z"
          fill="#F2F61C"
          fill-opacity="0.8"
        />
        <path
          d="M17.1113 0.000244141H28.0002V10.8891H26.4447V1.5558H17.1113V0.000244141Z"
          fill="#F2F61C"
          fill-opacity="0.8"
        />
        <path
          d="M28 17.1116V28.0005H17.1111V26.4449H26.4444V17.1116H28Z"
          fill="#F2F61C"
          fill-opacity="0.8"
        />
      </g>
      <g filter="url(#filter0_d_7057_1938)">
        <path
          d="M13.9998 4C12.1991 4 11.0014 5.90476 11.0014 7.40187L11.0014 22.5829C11.0014 22.8271 10.9253 23.5441 11.9008 23.8187C12.498 23.9865 13.9978 24 13.9978 24C13.9978 24 15.5017 23.9865 16.0989 23.8187C17.0757 23.5441 16.9986 22.8271 16.9986 22.5829V7.40187C16.9986 5.96825 15.8006 4 13.9998 4Z"
          fill="#DCDF35"
        />
      </g>
      <path
        d="M13.9606 11.1726C11.6053 11.1726 11.8116 12.6945 11.8116 13.4866C11.8116 14.2787 11.8116 21.8129 11.8116 21.8129H16.2579C16.2579 21.8129 16.2579 14.3919 16.2579 13.4866C16.2579 12.5813 16.316 11.1726 13.9606 11.1726Z"
        fill="#FAFF0F"
      />
      <path
        d="M15.3582 15.8184H12.7744C12.7146 15.8184 12.6572 15.8407 12.615 15.8805C12.5727 15.9203 12.5489 15.9743 12.5489 16.0306V19.5334C12.5489 19.6809 12.6112 19.8223 12.722 19.9266C12.8328 20.0309 12.983 20.0895 13.1397 20.0895H14.9929C15.1496 20.0895 15.2999 20.0309 15.4107 19.9266C15.5215 19.8223 15.5837 19.6809 15.5837 19.5334V16.0306C15.5837 15.9743 15.56 15.9203 15.5177 15.8805C15.4754 15.8407 15.4181 15.8184 15.3582 15.8184Z"
        fill="white"
      />
      <path
        d="M14.0663 15.2982C12.6322 15.2982 12.5489 16.0432 12.5489 16.0432V14.7178C12.5489 14.0555 13.8144 13.9451 14.0663 13.9451C14.3182 13.9451 15.5837 14.0555 15.5837 14.7178V16.0425C15.5837 16.0425 15.5005 15.2982 14.0663 15.2982Z"
        fill="white"
      />
      <path
        d="M14.0663 16.3465C12.6322 16.3465 12.5489 17.1669 12.5489 17.1669V15.8404C12.5489 15.2194 13.1427 14.9939 14.0663 14.9939C14.99 14.9939 15.583 15.2298 15.5837 15.8404V17.1669C15.5837 17.1669 15.5005 16.3465 14.0663 16.3465Z"
        fill="#0C51AF"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_7057_1938"
        x="9"
        y="3"
        width="10"
        height="24"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7057_1938"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7057_1938"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_7057_1938">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "VesselCourseCautionIcon",
};
</script>
